import { Component, ViewEncapsulation } from '@angular/core';
import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-multiple-search-select-input',
    templateUrl: './multiple-search-select-input.component.html',
    styleUrls: ['./multiple-search-select-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MultipleSearchSelectInputComponent extends BaseFormInput {
}
